export const ADD_MARKET_SETTINGS = 'ADD_MARKET_SETTINGS';

export const addMarketSettings = settings => ({
  type: ADD_MARKET_SETTINGS,
  payload: {
    settings,
  },
});



// WEBPACK FOOTER //
// ./src/store/market/actions.js